/**
 * Official UTMify tracking script loader.
 * Injects the UTMify UTM-tracking script exactly as provided by UTMify.
 * Safe to call multiple times — it will only inject once.
 */

const UTMIFY_SCRIPT_ID = 'utmify-utms-script'
const UTMIFY_SRC = 'https://cdn.utmify.com.br/scripts/utms/latest.js'

export function loadUtmify(): void {
  if (typeof document === 'undefined') return
  if (document.getElementById(UTMIFY_SCRIPT_ID)) return

  const script = document.createElement('script')
  script.id = UTMIFY_SCRIPT_ID
  script.src = UTMIFY_SRC
  script.async = true
  script.defer = true
  script.setAttribute('data-utmify-prevent-xcod-sck', '')
  script.setAttribute('data-utmify-prevent-subids', '')
  document.head.appendChild(script)
}
